import { StaticBaseDao } from '@/dao';
import { RelayTeamContestant, PostResponse } from '@/objects/generated';

export class RelayTeamContestantDao extends StaticBaseDao {
    public static async GetRelayTeamContestantsByContestantID(EventID: number, ContestantID: number): Promise<RelayTeamContestant[]> {
        return this.BaseFetchArray(
            RelayTeamContestant,
            `RelayTeamContestant/GetRelayTeamContestantsByContestantID` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (ContestantID == undefined ? '' : `ContestantID=${ContestantID}`),
            'GET',
        );
    }
    public static async GetRelayTeamContestantsByEvent(EventID: number): Promise<RelayTeamContestant[]> {
        return this.BaseFetchArray(
            RelayTeamContestant,
            `RelayTeamContestant/GetRelayTeamContestantsByEvent` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
    public static async SetChipFromParticipantID(
        relayTeamContestants: RelayTeamContestant[],
        EventID: number,
    ): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `RelayTeamContestant/SetChipFromParticipantID` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            relayTeamContestants,
        );
    }
    public static async DeleteEmptyRelayContestants(EventID: number): Promise<boolean | null> {
        return this.Get(`RelayTeamContestant/DeleteEmptyRelayContestants` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`));
    }
    public static async DeleteAllRelayContestants(EventID: number): Promise<boolean | null> {
        return this.Get(`RelayTeamContestant/DeleteAllRelayContestants` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`));
    }
    public static async ClearChipsOnEmptyRelayContestants(EventID: number): Promise<boolean | null> {
        return this.Get(`RelayTeamContestant/ClearChipsOnEmptyRelayContestants` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`));
    }
    public static async ClearChipsOnRelayContestants(EventID: number): Promise<boolean | null> {
        return this.Get(`RelayTeamContestant/ClearChipsOnRelayContestants` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`));
    }
}
